module.exports = "<app-message-page\n  title=\"404\"\n  description=\"Página no encontrada\"\n></app-message-page>\n"